import { siteInfo } from '@/mocks/siteData';

export default function Hero() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/30"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-24 md:py-28">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-100/70 text-primary-700 rounded-full text-sm font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>{siteInfo.tagline}</span>
            </div>

            <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-5">
              {siteInfo.name}
              <br />
              <span className="text-primary-600">{siteInfo.slogan}</span>
            </h1>

            <div className="space-y-3 mb-8">
              {siteInfo.introParagraphs.map((p, i) => (
                <p key={i} className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0">
                  {p}
                </p>
              ))}
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {siteInfo.stats.map((stat, i) => (
                <div key={i} className="text-center lg:text-left">
                  <div className="text-lg md:text-xl font-heading font-bold text-primary-600">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => handleNavClick(e, '#cards')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap text-center"
              >
                立即吃瓜 <i className="ri-arrow-right-line ml-1"></i>
              </a>
              <a
                href="#updates"
                onClick={(e) => handleNavClick(e, '#updates')}
                className="w-full sm:w-auto px-8 py-3 bg-background-100 text-foreground-700 font-medium text-sm rounded-lg hover:bg-background-200 transition-colors whitespace-nowrap text-center"
              >
                最新动态 <i className="ri-time-line ml-1"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-2xl blur-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20set%20behind%20the%20scenes%20with%20dramatic%20red%20and%20gold%20lighting%2C%20movie%20clapperboard%2C%20film%20reel%2C%20mysterious%20atmosphere%2C%20entertainment%20gossip%20magazine%20aesthetic%2C%20dark%20theater%20background%2C%20dramatic%20shadows%2C%20professional%20cinematography%20style&width=1200&height=900&seq=hero-main&orientation=portrait"
                alt="51电影网影视吃瓜爆料主视觉"
                className="relative w-full rounded-2xl object-cover aspect-[4/3] lg:aspect-[5/4]"
                title="51电影网 - 影视吃瓜第一站"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}